export default __webpack_public_path__ + "static/media/nextinit-logo.9e9475e0.png";